import { NavigationService } from '~ngx-shared/services';

export function appInitializerFactory(navigationService: NavigationService) {
  navigationService.init();
  return () => Promise.resolve();
}
